export default __webpack_public_path__ + "locales/fr/DownloadDialog.json?hash=dda28f7eb78f63bcd1576313b8ff5788";